import Layout from "~/layout/index.vue";

import { UserCenterRoutes } from "./modules/UserCenter";
import { SupplierRoutes } from "./modules/Supplier";
import { FinanceRoutes } from "./modules/Finance";
import { ProductCenterRoutes } from "./modules/ProductCenter";
import { StockMessageRoutes } from "./modules/StockMessage";
import { OrderRoutes } from "./modules/Order";
import OCRRoutes from "~/views/ocr-order/route-define";
import FeeCalcRoutes from "@/views/calc/route-define";
// import HKDeliverRoutes from "@/views/hk-deliver/route-define";

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("~/views/dashboard/Dashboard.vue"),
        meta: {
          anonymous: false,
          isBack: false,
          title: "首页",
          isHeaderShow: false,
        },
      },
    ],
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("~/views/Index/Index"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("~/views/login/Login"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("~/views/Register/index"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  {
    path: "/bindWeChat",
    name: "BindWeChat",
    component: () => import("~/views/BindWeChat/BindWeChat"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  {
    path: "/bindWeChatConfirm",
    name: "BindWeChatConfirm",
    component: () => import("~/views/BindWeChatConfirm/BindWeChatConfirm"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  {
    path: "/loginConfirm",
    name: "WeChatLoginConfirm",
    component: () => import("~/views/WeChatLoginConfirm/WeChatLoginConfirm"),
    meta: {
      anonymous: true,
      isBack: false,
    },
  },
  UserCenterRoutes,
  SupplierRoutes,
  FinanceRoutes,
  StockMessageRoutes,
  ProductCenterRoutes,
  OrderRoutes,
  OCRRoutes,
  FeeCalcRoutes,
  // HKDeliverRoutes
];

export default routes;
